import { createSelector } from 'reselect';

const selectAccountTypes = (state: any) => state.accountTypes;


export const selectAccountTypesCurrentItem = createSelector([selectAccountTypes], (accountTypes) => accountTypes.current);

export const selectAccountTypesListItems = createSelector([selectAccountTypes], (accountTypes) => accountTypes.list);

export const selectAccountTypesItemById = (itemId: any) =>
    createSelector(selectAccountTypesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectAccountTypesQueryItems = createSelector([selectAccountTypes], (accountTypes) => accountTypes.query);

export const selectAccountTypesCreatedItem = createSelector([selectAccountTypes], (accountTypes) => accountTypes.create);

export const selectAccountTypesUpdatedItem = createSelector([selectAccountTypes], (accountTypes) => accountTypes.update);

export const selectAccountTypesReadItem = createSelector([selectAccountTypes], (accountTypes) => accountTypes.read);

export const selectAccountTypesDeletedItem = createSelector([selectAccountTypes], (accountTypes) => accountTypes.delete);

export const selectAccountTypesSearchedItems = createSelector([selectAccountTypes], (accountTypes) => accountTypes.search);

export const selectAccountTypesItemsCount = createSelector([selectAccountTypes], (accountTypes) => accountTypes.count);

export const selectAccountTypesItemsFilter = createSelector([selectAccountTypes], (accountTypes) => accountTypes.filter);